import { addTimeToDate, dateTrunc, isBefore, stringToLocalDate } from "@hex-insights/core";

export enum PaymentStatus {
	Upcoming = "Upcoming",
	Overdue = "Overdue",
	Due = "Due",
	Paid = "Paid",
}

export function getPaymentStatusFromValues(amountDue: number, dueDate: string) {
	if (amountDue === 0) {
		return PaymentStatus.Paid;
	}

	const today = dateTrunc(new Date(), "day");
	const dueDateDate = stringToLocalDate(dueDate, "day");
	const minDueBound = addTimeToDate(dueDateDate, [-2, "days"]);
	const maxDueBound = addTimeToDate(dueDateDate, [2, "days"]);

	if (isBefore(today, minDueBound)) {
		return PaymentStatus.Upcoming;
	}
	if (isBefore(today, maxDueBound)) {
		return PaymentStatus.Due;
	}
	return PaymentStatus.Overdue;
}
